export default "__VITE_ASSET__2c08a39e__"